import { render, staticRenderFns } from "./ToDoList.vue?vue&type=template&id=2bd3e97a&scoped=true&"
import script from "./ToDoList.vue?vue&type=script&lang=js&"
export * from "./ToDoList.vue?vue&type=script&lang=js&"
import style0 from "./ToDoList.vue?vue&type=style&index=0&id=2bd3e97a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd3e97a",
  null
  
)

export default component.exports